exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".simple-container{width:100%;margin:0;padding:10px 25px;position:relative}.simple-container.has-overlay{position:relative}.simple-container.has-overlay:before{position:absolute;top:0;left:0;display:block;height:100%;width:100%;background:rgba(0,0,0,.35);content:\"\"}.white{background-color:#fff;color:#173031}.white a{color:#5f8f93;transition:color .3s ease}.white a:not(.button):not(.btn){text-decoration:underline}.white a:not(.button):not(.btn):not(.button):hover{color:#87ccd3}.white .highlight{color:#5f8f93}.light{background-color:#87ccd3;color:#fff}.dark{background-color:#5f8f93;color:#fff}@media screen and (min-width:780px){.simple-container{padding-right:20px}}@media screen and (min-width:1020px){.simple-container{padding-right:25px}}@media screen and (max-width:775px){.simple-container{padding-right:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/simplecontainer/simplecontainer.styl
// module id = 485
// module chunks = 0